/* eslint-disable function-paren-newline */
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Controller, useForm } from "react-hook-form";
import { useReactToPrint } from "react-to-print";
import useTablePage from '../hooks/useTablePage';
import { ModalDefaultDraggable, InputDatepickerRange, InputBaseContainer, ButtonWithLoader } from '../molecules';
import { DEFAULT_DATE_FORMAT, GET_ALL_QUERY_PARAMS } from '../constants';
import InspectorDashboardBlocks from "./InspectorDashboardBlocks";
import { FormsReportType, ReportTableType } from "../api/reports";
import { DatePicker } from "../atoms";
import { getActivitiesList, getActivitiesStatusList } from "../api/activities";
import { getCurrentUser } from "../api/userSettings";
import formatDate from "../utils/formatDate";
import useManuallyUpdate from "../hooks/useManuallyUpdate";
import DailyInspectorReport from "./Reports/InspectionReports/DailyInspectorReport";
import FormsReport from "./Reports/FormsReport";
import useDevice from '../hooks/useDevice';

const DashboardInspectionsPage = ({
  onSubmit,
}: Props) =>
{
 const [dates, setDates] = React.useState(
    {} as { fromDate: Date; toDate: Date });
 const {
    errors,
    control,
    handleSubmit,
    } = useForm<ReportTableType>({
    mode: 'onChange',
  });
 const [
    tableManuallyUpdate,
    updateTable,
  ] = useManuallyUpdate();
 const [
    isValidForExport,
    setIsValidForExport,
  ] = React.useState(false);
  const getDate = () => {
    const newDate = new Date();
    const year = newDate.getFullYear();
    const month = newDate.getMonth() + 1;
    const d = newDate.getDate();
        return `${month.toString().padStart(2, '0')}/${d.toString().padStart(2, '0')}/${year}`;
  };
  const [
    reportsSettings,
    setReportsSettings,
  ] = React.useState(null);

  const dailyTableRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => dailyTableRef.current,
   });
  const exportToPdf = () => {
      handlePrint();
    };

  const inspectionActivityID = [];
  const activityIds = data => {
     inspectionActivityID.push(data);
  };

  const activityStatus = [];
  const activityIds2 = data => {
     activityStatus.push(data);
  };

 const [
    inspectionStatuses,
    setInspectionStatus,
 ] = React.useState([]);

 const [key, setKey] = React.useState(1);
 const onChangeKey = () => {
    setKey(key + 1);
  };
 const [currentUser, setCurrentUser] = React.useState(
    null,
  );

 const {
    isModalOpen,
    modalError,
    modalSuccess,
    modalTitle,
    handleAdd,
    handleCloseModal,
    modalErrorTitle,
    handleCloseModalInfo,
   } = useTablePage({
    modalCreateTitle: 'Print Inspection Form',
  });
  const handleCloseForm = () => {
    if (!modalError && !modalSuccess) {
      handleCloseModal();
    }
  };
  const [forms, setForms] = React.useState<
  Array<FormsReportType>
>([]);
  const printableRef = React.useRef();
  const handlePrintInspectionForm = useReactToPrint({
    content: () => printableRef.current,
  });

  const formExportToPdf = () => {
      handlePrintInspectionForm();
  };
  const [
    selectedFormsReports,
    setSelectedFormsReports,
  ] = React.useState<Array<FormsReportType>>([]);

  const [isIpad] = useDevice();

  React.useEffect(() => {
    Promise.all([
      getCurrentUser(),
    ]).then(
      ([
        currentUserResponse,
      ]) => {
          setCurrentUser(currentUserResponse.data.id);
         },
    );
  }, []);

  React.useEffect(() => {
      Promise.all([
        getActivitiesList({
          ...GET_ALL_QUERY_PARAMS,
          activityType: 8,
        }),
        getActivitiesStatusList({
          ...GET_ALL_QUERY_PARAMS,
        }),
      ]).then(
        ([
          activitiesList,
          activitiesStatusList,
        ]) => {
          const activitiesTitles = activitiesList.data.results?.filter(
            el => el?.isActiveStatus === 'True',
            );

            activitiesTitles.forEach(item => {
              for (const key in item) {
                if (`${key}` === 'id')
                {
                  activityIds(`${item[key]}`);
                }
              }
            });

            const activitiesStatusLists = activitiesStatusList.data.results?.filter(
              el => el?.isActiveStatus === 'True' && el?.name === 'Pending'
              );

              for (let i = 0; i < inspectionActivityID.length; i++) {
                for (let j = 0; j < activitiesStatusLists.length; j++) {
                  if (inspectionActivityID[i] === activitiesStatusLists[j].activity.toString()) {
                    activityIds2(activitiesStatusLists[j].id);
                    break;
                  }
                }
              }
              setInspectionStatus(activityStatus);
            });
          }, []);

 const middleware = (submitFn: (data) => void) => data => {
    setReportsSettings(
                {
                    fromDate:
                        formatDate(
                            dates?.fromDate,
                            'yyyy-MM-dd',
                        ),
                    toDate:
                        formatDate(
                            dates?.toDate,
                            'yyyy-MM-dd',
                        ),
                    inspector: currentUser,
                    inspectionStatus: inspectionStatuses,
                });

    exportToPdf();
   };

 const formsMiddleware = (submitFn: (data) => void) => data => {
    setReportsSettings(
                {
                    formsDate:
                        formatDate(
                            dates?.fromDate,
                            'yyyy-MM-dd',
                        ),
                    inspector: currentUser,
                });
    handleAdd();
    // formExportToPdf()
  };

  const toolbarNode = (
    <Toolbar>
      <FormContainer
        autoComplete="off"
        aria-autocomplete="none"
      >
              <InputBaseContainer>
                <DateWrapper>
                  <Controller
                    name="formsDate"
                    defaultValue=""
                    control={control}
                    render={({ value, onChange }) => (
                      <DatePicker
                        onChange={(start:Date) => {
                          setDates({ fromDate: start, toDate: start });
                          setReportsSettings(
                          {
                              fromDate:
                                  formatDate(start),
                              toDate:
                                  formatDate(start),
                              inspectionStatus: inspectionStatuses,
                                 });
                         updateTable();
                            }
                      }
                        selected={dates.fromDate ? dates.fromDate : new Date(getDate())}
                        dateFormat={DEFAULT_DATE_FORMAT}
                        placeholderText="Select Date"
                        required
                      />
                  )}
                  />
                </DateWrapper>
              </InputBaseContainer>

              <ButtonContainer>
                <ButtonWithLoader
                  variant="outlined"
                  disabled={!isValidForExport}
                  onClick={handleSubmit(middleware(onSubmit))}
                >
                  Print Report
                </ButtonWithLoader>
                <ButtonWithLoader
                  variant="outlined"
                  disabled={!isValidForExport}
                  onClick={handleSubmit(formsMiddleware(onSubmit))}
                >
                  Inspection Form
                </ButtonWithLoader>
              </ButtonContainer>
              {isModalOpen && (
              <ModalDefaultDraggable
                onClose={handleCloseForm}
                title={modalTitle}
                extraWide
                showPrintButton
                printRef={printableRef}
              >
                {reportsSettings &&
                <FormsReport
                  key={key}
                  setSelectedFormsReports={
                            setSelectedFormsReports
                        }
                  selectedFormsReports={selectedFormsReports}
                  setIsValidForExport={setIsValidForExport}
                  ref={printableRef}
                  forms={forms}
                  setForms={setForms}
                  {...reportsSettings}
                />
                }
              </ModalDefaultDraggable>
              )}
            </FormContainer>
          </Toolbar>
  );

  return (
    <>
      <Container>
        <InspectorDashboardBlocks />
        {tableManuallyUpdate && updateTable && (
          <DailyInspectorReport
            modalErrorTitle={modalErrorTitle}
            handleCloseModalInfo={handleCloseModalInfo}
            modalError={modalError}
            key={key}
            ref={dailyTableRef}
            setIsValidForExport={setIsValidForExport}
            manuallyUpdate={tableManuallyUpdate}
            updateTable={updateTable}
            toolbar={toolbarNode}
            {...reportsSettings}
          />
        )}

      </Container>
      {isIpad && <><br /> <br /></>}
    </>
  );
};

const FONT_STACK = `'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif`;

const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: ${FONT_STACK};
`;

const Card = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-xs);
  padding: 24px;
  margin-bottom: 20px;
  font-family: ${FONT_STACK};
`;

const SectionTitle = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--mainText);
  margin-bottom: 20px;
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const FormContainer = styled.form`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;

  > div {
    width: auto;
    padding: 0;
    margin: 0;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  .MuiButton-root {
    text-transform: none;
    letter-spacing: 0.01em;
    border-radius: 8px;
    height: 40px;
    min-width: 140px;
    font-weight: 600;
    font-size: 0.875rem;
  }
`;

const DateWrapper = styled.div`
  input {
    cursor: pointer;
    width: 180px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid var(--border);
    padding: 0 14px;
    font-size: 0.875rem;
    color: var(--mainText);
    background: var(--neutral-0);
    font-family: ${FONT_STACK};
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &::placeholder {
      color: var(--neutral-500);
      font-size: 0.875rem;
    }

    &:focus {
      outline: none;
      border-color: var(--primary-600);
      box-shadow: var(--shadow-focus);
    }
  }
`;

export interface Props {
  onSubmit: (data: ReportTableType) => void;
  onExportToPDF: (data: ReportTableType) => void;
}

export default DashboardInspectionsPage;
